import React from "react";
import ReactDOM from 'react-dom';

class ArrowLabel1 extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isActive: false };
    }
  
    componentDidMount() {
      this.setState({
        isActive: false
      });
    }
    
    _handleClick(e){
      e.preventDefault();
      const label__chevron_down = document.getElementById('label__chevron_down');
      if (label__chevron_down.classList.contains('collapsed')) {
          this.setState({ isActive: false });
      }else{
          this.setState({ isActive: true });
      }
    }
  
    render() {
      const arrowLabel1Value = document.getElementById('arrow-label1-value').value;
      return (
        <a className={`nav-link mb-4 dropdown-toggle label__chevron_down collapsed ${this.state.isActive ? 'active' : ''}`} id="label__chevron_down" data-toggle="collapse" href="#navitemDropdown10" role="button" aria-expanded="false" aria-controls="navitemDropdown10" onClick={(e) => this._handleClick(e)}>{arrowLabel1Value}</a>
      );
    }
  
  }
  
  if(document.getElementById('arrow-label1')) {
    ReactDOM.render(<ArrowLabel1 />, document.getElementById('arrow-label1'));
  }

  class ArrowLabel2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isActive: false };
    }
  
    componentDidMount() {
      this.setState({
        isActive: false
      });
    }
    
    _handleClick(e){
      e.preventDefault();
      const label__chevron_down = document.getElementById('label__chevron_down2');
      if (label__chevron_down.classList.contains('collapsed')) {
          this.setState({ isActive: false });
      }else{
          this.setState({ isActive: true });
      }
    }
  
    render() {
      const arrowLabel2Value = document.getElementById('arrow-label2-value').value;
      return (
        <a className={`nav-link mb-4 dropdown-toggle label__chevron_down collapsed ${this.state.isActive ? 'active' : ''}`} id="label__chevron_down2" data-toggle="collapse" href="#navitemDropdown20" role="button" aria-expanded="false" aria-controls="navitemDropdown20" onClick={(e) => this._handleClick(e)}>{arrowLabel2Value}</a>
      );
    }
  
  }
  
  if(document.getElementById('arrow-label2')){
    ReactDOM.render(<ArrowLabel2 />, document.getElementById('arrow-label2'));
  }

  class ArrowLabel3 extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isActive: false };
    }
  
    componentDidMount() {
      this.setState({
        isActive: false
      });
    }
    
    _handleClick(e){
      e.preventDefault();
      const label__chevron_down = document.getElementById('label__chevron_down3');
      if (label__chevron_down.classList.contains('collapsed')) {
          this.setState({ isActive: false });
      }else{
          this.setState({ isActive: true });
      }
    }
  
    render() {
      const arrowLabel3Value = document.getElementById('arrow-label3-value').value;
      return (
        <a className={`nav-link mb-4 dropdown-toggle label__chevron_down collapsed ${this.state.isActive ? 'active' : ''}`} id="label__chevron_down3" data-toggle="collapse" href="#navitemDropdown30" role="button" aria-expanded="false" aria-controls="navitemDropdown30" onClick={(e) => this._handleClick(e)}>{arrowLabel3Value}</a>
      );
    }
  
  }
  
  if(document.getElementById('arrow-label3')){
    ReactDOM.render(<ArrowLabel3 />, document.getElementById('arrow-label3'));
  }